import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import RequiredDocForm from './RequiredDocForm';
import CustomSpinner from './CustomSpinner';
import { WAButton } from '../components/Button.js';
import FlowProgressBar from "./FlowProgressBar";

class Documents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            requiredDocuments: {
                personal_document: false,
                cbu: false,
                credit_card: false,
            }
        };
        this.updateDocumentStatus = this.updateDocumentStatus.bind(this);
    }

    updateDocumentStatus(documentType){
        let newState = {...this.state};
        newState.requiredDocuments[documentType] = true;
        this.setState({...newState});
    }


    render() {
        const { handleSubmit, submitting, error } = this.props;
        const { requiredDocuments:{ personal_document, cbu, credit_card } } = this.state;
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_documents" description="Sms info"/>
                        </div>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <FlowProgressBar/>
                        <form  className="pvc-form" onSubmit={handleSubmit(this.props.getStep)}>
                        {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <RequiredDocForm
                                        label={'Frente del DNI'}
                                        documentType={'personal_document'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                    <RequiredDocForm
                                        label={'Frente tarjeta Montemar (No Mastercard)'}
                                        documentType={'credit_card'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                    <RequiredDocForm
                                        label={'Comprobante CBU cuenta sueldo (cajero o web)'}
                                        documentType={'cbu'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={!(personal_document && credit_card && cbu)}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

Documents.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

Documents = TopScrolleable(Documents);

Documents = reduxForm({
    form: 'Documents', // a unique name for this form
})(Documents);

Documents = withAuthControl(Documents);

export default Documents;


/** WEBPACK FOOTER **
 ** ./src/components/Documents.js
 **/